import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'

Vue.use(Router)
const userCenterRouter =[
  {
    path: '/',
    component: Layout,
    name:"userCenter",
    linkActiveClass:'active',
    children: [
    {
      path: '/userCenter-manage',
      component: () => import('@/views/userCenter/userCenter-manage'),//个人中心-个人账号管理
      name: 'userCenter-manage',
      linkActiveClass:'active',
      meta:{
      	requireAuth:true
      }
    },
    {
         path:'/userCenter-ident',
          component: () => import('@/views/userCenter/userCenter-ident'),//个人中心-个人账号管理-身份证上传
          name: 'userCenter-ident',
          linkActiveClass:'active',
         meta:{
          requireAuth:true
        } 
    },
    {
    	path:'/userCenter-changePwd',
    	component:()=>import('@/views/userCenter/userCenter-changePwd'),//个人中心-修改密码
      name:'userCenter-changePwd',
      linkActiveClass:'active',
      meta:{
      	requireAuth:true
      }
    },
    {
    	path:'/userCenter-message',
    	component:()=>import('@/views/userCenter/userCenter-message'),//个人中心-意见和建议
      name:'userCenter-message',
      linkActiveClass:'active',
      meta:{
      	requireAuth:true
      }
    },
    {
      path:'/userCenter-info',
      component:()=>import('@/views/userCenter/userCenter-info'),//个人中心-系统通知消息
      name:'userCenter-info',
      linkActiveClass:'active',
      meta:{
        requireAuth:true
      }
    }
    ]
	}
]
export default userCenterRouter



// WEBPACK FOOTER //
// ./src/router/userCenter.js